import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TalentComponent } from './talent/talent.component';
import { WelfareComponent } from './welfare/welfare.component';
import { RecruitListComponent } from './recruit-list/recruit-list.component';
import { FormsModule } from '@angular/forms';
import { RecruitComponent } from './recruit.component';
import { RouterModule } from '@angular/router';
import { RecruitDetailComponent } from './recruit-detail/recruit-detail.component';



@NgModule({
  declarations: [
    TalentComponent,
    WelfareComponent,
    RecruitListComponent,
    RecruitComponent,
    RecruitDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class RecruitModule { }
